import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CurrentDialogEnum } from 'types/types';
import { StoreNames } from 'store/types';

interface ManagementState {
  currentDialog: CurrentDialogEnum;
  helperDrawer: {
    open: boolean;
  };
}

export const initialManagementState: ManagementState = {
  currentDialog: CurrentDialogEnum.None,
  helperDrawer: {
    open: false,
  },
};

const managementSlice = createSlice({
  name: StoreNames.management,
  initialState: initialManagementState,
  reducers: {
    setCurrentDialog: (state, { payload: { currentDialog } }: PayloadAction<{ currentDialog: CurrentDialogEnum }>) => {
      state.currentDialog = currentDialog;
    },
    closeCurrentDialog: state => {
      state.currentDialog = CurrentDialogEnum.None;
    },
    openHelperDrawer: state => {
      state.helperDrawer.open = true;
    },
    closeHelperDrawer: state => {
      state.helperDrawer.open = false;
    },
  },
});

export const { reducer: managementReducer, actions: managementActions } = managementSlice;
